<template>
  <div>
    <div class="activity_boxs">
      <el-carousel indicator-position="outside"
                   style="width:100%"
                   arrow="never"
                   height="460px">
        <el-carousel-item v-for="(x,y) in list"
                          :key="y+'x'">
          <div class="activity_list">
            <div class="activity_items"
                 :style="{'width':'calc((100% - 60px) /'+ 3 +')'}"
                 @click="toActivity(item)"
                 v-for="(item,index) in  x"
                 :key="index">
              <el-image style="width:100%; height: 244px;border-radius: 10px 10px 0 0;"
                        :src="item.bannerUrl"></el-image>
              <div class="activity_content">
                <div class="activity_item_title"
                     v-if="item.outerName">{{item.outerName.length>35?item.outerName.slice(0,34)+'...':item.outerName}}</div>
                <div class="flexStart"
                     style="margin:10px 0;align-items:flex-start;">
                  <!-- <div style="flex:1">{{item.startTime}}-{{item.endTime}}·{{item.address}}</div> -->
                  <div style="flex:1;color:#666;"
                       class="font14">
                    <!-- {{item.introduce.length>20?item.introduce.slice(0,18)+'...':item.introduce}}  -->
                    <div style="font-weight:400;color:#666;"
                         v-if="item.startTimeShort">{{item.startTimeShort+'至'+item.endTimeShort}}</div>
                    <div class="flexStart font14"
                         style="font-weight:400;color:#666;margin-top: 4px;">
                      <!-- <i class="el-icon-time"
                         style="margin-right:3px"></i> -->
                      {{item.courseClassify && item.courseClassify == '1'?item.areaStr:''}}
                    </div>
                  </div>
                  <div class="mainColor font14"
                       style="font-weight:400;"
                       v-if="item.remainNum && item.remainNum>0 && item.activityState!=3">仅剩{{item.remainNum}}名额</div>
                </div>
                <div class="flexCenter end"
                     style="margin:0">
                  <div style="flex:1;color:#999999;font-size:14px">主讲老师：{{item.lectureName}}</div>
                  <el-button type="danger"
                             v-if="item.activityState!=3"
                             size="mini"
                             round>立即报名</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  data () {
    return {
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800'
    }
  },
  methods: {
    toActivity (item) {
      this.$router.push('/Activity?id=' + item.id)
    }
  }
}
</script>
<style lang="less" scoped>
.activity_boxs {
  width: 1200px;
  margin: 0 auto;
  .activity_top {
    display: flex;
    .activity_title {
      flex: 1;
    }
  }
  .activity_list {
    width: 100%;
    display: flex;
    margin: 20px 0;
    .activity_items {
      background-color: #fff;
      margin-right: 30px;
      border-radius: 10px;
      cursor: pointer;
      position: relative;
      .end {
        position: absolute;
        left: 20px;
        bottom: 20px;
        margin: 0 20px;
        box-sizing: border-box;
        width: calc(100% - 40px);
      }
      .activity_content {
        padding: 20px 20px 40px 20px;
        box-sizing: border-box;
        .activity_item_title {
          width: 100%;
          // width: 200px;
          color: #333333;
          font-size: 18px;
          // text-overflow: ellipsis-lastline;
          // display:box;
          // text-overflow: ellipsis;
          // overflow: hidden;
          // -webkit-line-clamp: 2;
          // -webkit-box-orient: vertical;
        }
        .flexCenter {
          margin: 16px 0 20px 0;
        }
      }
    }
    .activity_items:nth-child(3) {
      margin-right: 0;
    }
  }
}
</style>